import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import '../Login.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { format } from 'date-fns';
import { UserContext } from '../common/UserContext';
import config from '../../envconfig';
import { Modal, Button } from 'react-bootstrap';

const EditOrderStatus = () => {
    const { ORDM_OrderNumber } = useParams();
    const [orderDetails, setOrderDetails] = useState({});
    const [productDetails, setProductDetails] = useState([]);
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
    const [productNames, setProductNames] = useState([]);
    const [schemeData, setSchemeData] = useState([]);
    const [showExpiredModal, setShowExpiredModal] = useState(false);
    const [expiredSchemeName, setExpiredSchemeName] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [actionType, setActionType] = useState('');
    const navigate = useNavigate();
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  
    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);

        sessionStorage.setItem('selectedScpId', selectedScpId);

    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);


    useEffect(() => {
        const fetchProductNames = async () => {
            try {
                const response = await fetch(`${config.API_URL}/productnames/${UM_CompanyID}`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                console.log(data)
                setProductNames(data.PL_ProductName);
            } catch (error) {
                console.error('Error fetching product names:', error);
            }
        };

        fetchProductNames();
    }, [UM_CompanyID]);

    useEffect(() => {

        fetchData();
    }, [ORDM_OrderNumber]);


    const fetchData = async () => {
        try {

            console.log("fetchdata")
            // 📦 Fetch order details
            const orderRes = await axios.get(
                `${config.API_URL}/OM/pdf/orders/${ORDM_OrderNumber}`
            );
            setOrderDetails(orderRes.data[0]);

            // 📦 Fetch product details
            const productRes = await axios.get(
                `${config.API_URL}/OM/pdf/product/${ORDM_OrderNumber}`
            );
            setProductDetails(productRes.data);
            setSchemeData([]);
            // 🎯 Fetch scheme details
            const schemeRes = await axios.get(
                `${config.API_URL}/OM/orderscheme/${ORDM_OrderNumber}`
            );

            console.log("🎯 Scheme Details:", schemeRes.data);
            setSchemeData(schemeRes.data);

            // 🔍 Extract the schemes array safely
            const schemesArray = Array.isArray(schemeRes.data?.schemes)
                ? schemeRes.data.schemes
                : [];

            // 🚨 Check for expired scheme
            const expiredScheme = schemesArray.find(
                (scheme) => Number(scheme.isExpired) === 1
            );

            if (expiredScheme) {
                console.warn("⚠️ Expired scheme found:", expiredScheme.SchemeName);
                setExpiredSchemeName(expiredScheme.SchemeName);
                setShowExpiredModal(true);
            }

        } catch (error) {
            if (error.response?.status === 404) {
                console.log("ℹ️ No scheme found for this order.");
            } else {
                console.error("❌ Error fetching data:", error);
                toast.error("Error fetching order or scheme details");
            }
        }
    };



    const formatDate = (date) => {
        return format(new Date(date), 'dd/MM/yyyy');
    }

    const mergedProducts = React.useMemo(() => {
        if (!schemeData?.schemes?.length) return productDetails;

        const freeSchemes = schemeData.schemes.filter((s) => s.SchemeType === 2);
        if (!freeSchemes.length) return productDetails;

        // Clone main order list
        const updatedProducts = [...productDetails];

        freeSchemes.forEach((scheme) => {
            (scheme.freeProducts || []).forEach((freeItem) => {
                // Handle field name mismatches safely
                const freeId =
                    freeItem.freeProductId || freeItem.PL_ProductId || freeItem.productId;
                const freeName =
                    freeItem.freeProductName || freeItem.PL_ProductName || "Unknown";
                const freeCode =
                    freeItem.freeProductCode || freeItem.PL_ProductCode || "-";
                const freeQty = freeItem.freeQuantity || freeItem.ORDIT_FreeQty || freeItem.ORDIT_OrderQTY;

                // 🔍 Find product already in the order
                const existingIndex = updatedProducts.findIndex(
                    (p) => String(p.PL_ProductId) === String(freeId)
                );

                if (existingIndex !== -1) {
                    // ✅ Product already exists → append free quantity
                    const existingQty = updatedProducts[existingIndex].ORDIT_OrderQTY;
                    if (!String(existingQty).includes("(Free)")) {
                        updatedProducts[existingIndex] = {
                            ...updatedProducts[existingIndex],
                            ORDIT_OrderQTY: `${existingQty} + ${freeQty} (Free)`,
                        };
                    }
                } else {
                    // 🚀 Add new product row for free product
                    updatedProducts.push({
                        PL_ProductId: freeId,
                        PL_ProductName: freeName,
                        PL_ProductCode: freeCode,
                        ORDIT_OrderQTY: `${freeQty} (Free)`,
                        isFree: true,
                    });
                }
            });
        });

        return updatedProducts;
    }, [productDetails, schemeData]);



    const EditStatus = async (status, comment = '') => {
        console.log(status, comment);
   
        try {
            const response = await fetch(`${config.API_URL}/OA/update-order-status`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ ORDM_OrderNumber, status, comment })
            });
            const data = await response.text();
            console.log(data);


            let message = "";
            let transactionDetails = [];

            if (status === 2) {
                message = `Order : ${ORDM_OrderNumber} approved successfully.`;
                transactionDetails = []; // no details on approval
            }

            if (status === 3) {
                message = `Order : ${ORDM_OrderNumber} rejected successfully.`;
                transactionDetails = [
                    {
                        AUTRN_OldValue: "-",
                        AUTRN_NewValue: comment,
                        AUTRN_ParamererName: "Reject Remark",
                    }
                ];
            }

            logAudit(
                "Order Approval",
                message,
                UM_CompanyID,
                UM_CompanyGrpID,
                "-",
                ORDM_OrderNumber,
                false,
                transactionDetails
            );

            if (data === 'Order status updated successfully.') {
                toast.success(message, {
                    autoClose: 1500,
                    onClose: () => navigate(`/dashboard/OrderVerification`)
                });
            }

        } catch (error) {
            console.error('Error updating order status:', error);
        }
    };

    const handleOpenModal = (action) => {
        setActionType(action);
        setShowModal(true);
    };

    const logAudit = async (
        module,
        message,
        CompanyID,
        CompanyGrpID,
        oldValue = "",
        newValue = "",
        isError = false,
        transactionDetails = []
    ) => {
        const auditLogPayload = {
            AUTR_ScreenName: module,
            AUTR_OldValue: oldValue,
            AUTR_NewValue: newValue,
            AUTR_CompanyGrpId: CompanyGrpID,
            AUTR_CompanyID: CompanyID,
            AUTR_Message: message,
            AUTR_UserID: UM_UserId,
            AUTR_UserName: UM_UserCode,
            AUTR_AuditType: 11,
            AUTR_SCPID: selectedScpId || 0,
            AUTR_CreatedBy: UM_UserId,
            insertAuditTransaction: transactionDetails.length > 0, // Flag to determine if transaction details should be inserted
            transactionDetails, // Array of transaction details to be inserted into audittransaction
        };

        try {
            const response = await fetch(`${config.API_URL}/audit/log`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(auditLogPayload),
            });

            if (!response.ok) {
                throw new Error("Failed to log action");
            }
        } catch (error) {
            console.error("Error logging action:", error);
        }
    };

const handleConfirmAction = () => {
    setIsButtonDisabled(true);

    if (actionType === 'accept') {
        EditStatus(2);
    } 
    else if (actionType === 'reject') {
        if (!remark.trim()) {
            setError('*');
            setIsButtonDisabled(false);  // 🔥 RESET when validation fails
            return;
        }
        EditStatus(3, remark);
    }
    handleCloseModal();
};

const handleCloseModal = () => {
    setShowModal(false);
    setActionType('');
    setRemark('');
    setError('');
    setIsButtonDisabled(false);  // 🔥 RESET HERE
};


    const [remark, setRemark] = useState('');
    const [error, setError] = useState('');

    const handleRemarkChange = (e) => {
        const value = e.target.value;
        setRemark(value);
        if (error && value.trim() !== '') {
            setError(''); // Clear the error once the user starts typing
        }
    };




    return (
        <>
            <ToastContainer style={{
                marginTop: '73px',
                fontSize: '14px',
                width: '40%',
            }} />
            <div className='main_container' id='container'>
                <h4 className="formHeading">
                    Order Approval
                </h4>
                <div className="row mb-4">
                    <div className="col-md-3">
                        <label htmlFor="orderNumber">Order Number</label>
                        <input type="text" id="orderNumber" value={orderDetails.ORDM_OrderNumber || ''} readOnly className="form-input" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="orderDate">Order Date</label>
                        {/* <div className="form-input"> */}
                        <input
                            type="text"
                            id="orderDate"
                            value={orderDetails.ORDM_OrderDate ? formatDate(orderDetails.ORDM_OrderDate) : ''}
                            readOnly
                            className="form-input"
                        />

                    </div>
                    <div className="col-md-3">
                        <label htmlFor="orderType">Order Type</label>
                        <div className='select-container'>
                            <input
                                type="text"
                                id="orderType"
                                value={orderDetails.ORDM_TypeDescription || ''}
                                readOnly
                                className='select-box'
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="orderStatus">Order Status</label>

                        <input className='form-input' value={orderDetails.ORDM_OrderStatusDescription} readOnly />

                    </div>
                </div>


                {schemeData && schemeData.schemes?.length > 0 && (
                    <div
                        className="border-0 p-4 mb-3 rounded-xl shadow-sm reward-card animate-fadeIn"
                        style={{
                            borderRadius: "12px",
                            background: "linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%)",
                            position: "relative",
                            overflow: "hidden",
                            boxShadow: "0 4px 12px rgba(16, 185, 129, 0.08)",
                            transition: "transform 0.2s ease, box-shadow 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "translateY(-2px)";
                            e.currentTarget.style.boxShadow = "0 8px 20px rgba(16, 185, 129, 0.15)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "0 4px 12px rgba(16, 185, 129, 0.08)";
                        }}
                    >
                        {/* Animated Pulse Background */}
                        <div
                            className="absolute inset-0 opacity-30 pointer-events-none"
                            style={{
                                background:
                                    "radial-gradient(circle at 20% 80%, rgba(34, 197, 94, 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(16, 185, 129, 0.25) 0%, transparent 50%)",
                                animation: "pulse 6s ease-in-out infinite",
                            }}
                        />

                        {/* Header */}
                        <div className="flex items-center gap-2 mb-3">


                            {/* 🎉 Benefits Section */}
                            <h6 className="fw-bold text-success mb-2">
                                🎉 Scheme Benefits
                            </h6>
                        </div>

                        {/* Schemes List */}
                        <div className="space-y-3">
                            {schemeData.schemes.map((scheme, index) => (
                                <div
                                    key={index}
                                    className="group p-3 rounded-lg bg-white/70 backdrop-blur-sm border border-emerald-100 transition-all duration-200 hover:bg-white hover:shadow-md"
                                    style={{
                                        borderBottom: index !== schemeData.schemes.length - 1 ? "1px dashed #a7f3d0" : "none",
                                    }}
                                >
                                    {/* Scheme Name */}
                                    <div className="font-semibold text-emerald-800 text-base flex items-center gap-1.5">
                                        <span className="text-emerald-600">✦</span> {scheme.SchemeName}
                                    </div>

                                    {/* Description */}
                                    <p className="text-sm text-gray-600 mt-1 leading-relaxed">
                                        {scheme.SchemeDescription}
                                    </p>

                                    {/* Dynamic Benefit */}
                                    <div className="mt-2 flex items-center gap-1.5 text-sm font-medium">
                                        {scheme.SchemeType === 1 && (
                                            <>
                                                <span className="text-2xl">💰</span>
                                              <span>
                                                    You will receive a{' '}
                                                    <strong>
                                                      {scheme.SchemeValue}
                                                        {scheme.DiscountType === 1
                                                            ? ' %'
                                                            : scheme.DiscountType === 2
                                                                ? ' Rs.'
                                                                : ''}
                                                    </strong>{' '}
                                                     discount
                                                </span>
                                            </>
                                        )}

                                        {scheme.SchemeType === 3 && (
                                            <>
                                                <span className="text-2xl">🎁</span>
                                                <span>
                                                    Free{" "}
                                                    <strong className="text-emerald-700">
                                                        {scheme.SchemeValue} × {scheme.GiftArticle}
                                                    </strong>{" "}
                                                    as a gift article
                                                </span>
                                            </>
                                        )}

                                        {scheme.SchemeType === 2 && (
                                            <>
                                                <span className="text-2xl">🆓</span>
                                                <span className="text-emerald-700 font-semibold">{scheme.Benefit}</span>
                                            </>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>


                    </div>
                )}

                <div className="border p-3">
                   
                    <div className="form-only">
                        <div className="row g-3">
                            <div className="col">
                                <label htmlFor="fromScp" className="label1">From</label>
                                <div className="d-grid">
                                    <input
                                        type="text"
                                        id="scpname"
                                        value={orderDetails.ORDM_FromSCPName || ''}
                                        readOnly
                                        className='routing_select-box'
                                    />
                                </div>
                            </div>
                            <div className="col">
                                <label htmlFor="toScp" className="label1">To</label>
                                <div className="d-grid">
                                    <input
                                        type="text"
                                        id="scpNameDropdown"
                                        value={orderDetails.ORDM_ToSCPName || ''}
                                        readOnly
                                        className='routing_select-box'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-4">
                    <table className="tableClass">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Product Name</th>
                                <th>Product Code</th>
                                <th>Order Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {mergedProducts.map((product, index) => (
                                <tr
                                    key={index}
                                    style={product.isFree ? { backgroundColor: "#f8f9fa" } : {}}
                                >
                                    <td>{index + 1}</td>
                                    <td>{product.PL_ProductName}</td>
                                    <td>{product.PL_ProductCode}</td>
                                     <td>
                    {(() => {
                      const qtyText = String(product.ORDIT_OrderQTY ?? ""); // ensure string
                      const freeMatch = qtyText.match(/(\d+)\s*\(Free\)/); // detect "3 (Free)"
                      const hasFree = Boolean(freeMatch);

                      if (hasFree) {
                        const mainPart = qtyText.replace(freeMatch[0], "").replace("+", "").trim(); // remove main and extra "+"
                        const freePart = freeMatch[0]; // "3 (Free)"

                        return (
                          <>
                            {mainPart ? (
                              <>
                                {mainPart}{" "}
                                <span style={{ color: "green", fontWeight: 500 }}>
                                  + {freePart}
                                </span>
                              </>
                            ) : (
                              <span style={{ color: "green", fontWeight: 500 }}>
                                {freePart}
                              </span>
                            )}
                          </>
                        );
                      }

                      return qtyText;
                    })()}
                  </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <Modal
                    show={showExpiredModal}
                    onHide={() => setShowExpiredModal(false)}
                    backdrop="static" centered keyboard={false}
                    style={{ backdropFilter: 'blur(3px)', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}
                >
                    <Modal.Header>
                        <Modal.Title>Scheme Expired</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p style={{ fontSize: "16px", marginBottom: "0" }}>
                            Scheme : <strong>{expiredSchemeName}</strong> has expired.
                        </p>
                        <p style={{ marginTop: "8px", color: "#b00", fontWeight: "500" }}>
                            The applicable scheme benefits will not be applied to the current order.
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            variant="primary"
                            onClick={() => {
                                setShowExpiredModal(false);
                                fetchData(); // 🔁 Re-fetch latest data after cleanup
                            }}
                        >
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>


            </div>
            <div className='button-container'>
                <button onClick={() => handleOpenModal('accept')} className="save_btn" disabled={isButtonDisabled}>APPROVE</button>
                <button onClick={() => handleOpenModal('reject')} className="reset_btn" disabled={isButtonDisabled}>REJECT</button>
                <Link className='list_btn' to='/dashboard/OrderVerification'>BACK</Link>
            </div>

            {showModal && (
                <div className="popup_overlay">
                    <div className="resetpopup">
                        <h1>:: User Confirmation ::</h1>
                        <h4>Are you sure you want to {actionType === "accept" ? "Approve" : "Reject"} Order :{" "}
                            {ORDM_OrderNumber} ?</h4>
                        {actionType === "reject" && (
                            <div className='remark_container'>
                                <span className="me-3 remark_label">
                                    Remark : {error && <span style={{ color: "red" }}>{error}</span>}
                                </span>

                                <textarea
                                    type='text'
                                    className='remark_text'
                                    id="remarks"
                                    value={remark}
                                    onChange={handleRemarkChange}
                                    placeholder="Enter reject remarks"
                                    style={{
                                        border: '1px solid #ced4da',
                                        padding: '10px',
                                        fontSize: '16px',
                                        resize: 'none',  // Prevent resizing
                                        overflow: 'auto',  // Enable scrollbars when content overflows
                                        transition: 'height 0.3s',
                                        borderRadius: "5px",
                                        outline: "none"
                                    }}
                                />
                            </div>
                        )}


                        {/* Footer Buttons */}
                        <div className="popup_btn_container">
                            <button onClick={handleConfirmAction} className="yes_btn" >
                                YES
                            </button>
                            <button onClick={handleCloseModal} className="no_btn">
                                NO
                            </button>
                        </div>
                    </div>
                </div>
            )}


        </>
    );
};

export default EditOrderStatus;
